module.exports = __webpack_public_path__ + "static/media/practice-question-divider.30171152.png";